import React, { useState } from 'react';
import { navigateToSalesPortalRoute } from '@/experiences/sales-portal/sales-portal-route-config';
import { OnlineMenuDialog } from '@/experiences/sales-portal/components/create-order-guide/online-menu-dialog';
import { SALES_PORTAL_ROUTES } from '@/navigators/routes';
import { SalesPortalStackParams } from '@/navigators/types';
import { StackNavigationProp } from '@react-navigation/stack';
import { useCreateOrderGuideFromMenuMutator } from '@/experiences/sales-portal/blocs/mutators/use-create-order-guide-from-menu-mutator';
import { useNavigation } from '@react-navigation/native';
import { useOnlineMenuLoader } from '@/experiences/sales-portal/blocs/loaders/use-online-menu-loader';

interface OnlineMenuModalProps {
  isOpen: boolean;
  onClose: () => void;
  restaurantName?: string;
  restaurantUUID: string;
  supplierUUID: string;
}

export const OnlineMenuModal: React.FC<OnlineMenuModalProps> = ({
  isOpen,
  onClose,
  restaurantName,
  restaurantUUID,
  supplierUUID,
}) => {
  const navigation =
    useNavigation<StackNavigationProp<SalesPortalStackParams>>();
  const [generationFailed, setGenerationFailed] = useState(false);
  const { error, loading, menuItems, refetch } = useOnlineMenuLoader({
    restaurantUUID,
    skip: !isOpen,
    supplierUUID,
  });
  const { createOrderGuideFromMenu, creating } =
    useCreateOrderGuideFromMenuMutator({ restaurantUUID, supplierUUID });

  const handleGenerate = async () => {
    setGenerationFailed(false);
    const createdOrderGuide = await createOrderGuideFromMenu();
    if (!createdOrderGuide) {
      setGenerationFailed(true);
      return;
    }
    navigateToSalesPortalRoute(navigation, SALES_PORTAL_ROUTES.OrderGuides, {
      orderGuideUUID: createdOrderGuide.orderGuideCollectionUUID,
      partitionUUID: createdOrderGuide.orderGuidePartitionUUID,
      restaurantUUID,
      supplierUUID,
    });
    onClose();
  };

  const handleClose = () => {
    setGenerationFailed(false);
    onClose();
  };

  return (
    <OnlineMenuDialog
      generating={creating}
      generationFailed={generationFailed}
      hasError={Boolean(error)}
      isOpen={isOpen}
      loading={loading}
      menuItems={menuItems}
      onClose={handleClose}
      onGenerate={handleGenerate}
      onRetry={refetch}
      restaurantName={restaurantName}
    />
  );
};
